define(function () {
	const IPS = require('../base/ipsModelCollection');
    const builder = require('civicsUtils/buildUrlParameters');
	const AvailableFeatures = require('civicsUtils/available_features');

	return IPS.extend({
		urlRoot: '/delegate/civics-api/api/cdr/applications/{0}/{1}/statuschecks',
		url: function () {
			//return this.urlRoot.format(this.type, this.id);
			var parameters = "";
			if (this.urlParameters != undefined)
				parameters = builder.buildUrlParameters(this.urlParameters);

			if (parameters.indexOf("?") >= 0)
				parameters += "\x26Page\x3d[{Max:0}]";
			else
				parameters += "?Page\x3d[{Max:0}]";

			return this.urlRoot.format(this.type, this.id) + parameters
		},
		parse: function (response) {
			var data = response.data;
			if (this.processStatusChecks) {
				var newData = [];
				var addedPlanningConditionsTitle = false;
				//Get top level status checks
				$.each(data, function (index, el) {
					//normalize the status type values. Normalize!
					switch(el.statusType){
						case 'ConditionUnapproved':
						case 'ConditionApproval':
							el.statusType = 'Condition';
							break;
						case 'Fee':
							el.statusType = 'FeeStatus';
							break;
						case 'Inspection':
							el.statusType = 'InspectionResult';
							break;
						case 'Required License':
							el.statusType = 'RequiredLicense';
							break;
						case 'Endorsement':
							el.statusType = 'Endorsement';
							break;
						case 'Open Case':
							el.statusType = 'OpenCase';
							break;
						case 'Review':
							el.statusType = 'ReviewResult';
							break;
						case 'Planning Condition':
							el.statusType = 'PlanningConditionUnapproved';
							break;
						case 'Next Renewal Date':
							el.statusType = 'NextRenewalDate';
							break;
					}
					if (el.title && el.title.toLowerCase() == 'y'
						&& el.status.toLowerCase() != 'passed'
						&& el.status.toLowerCase() != 'successful'
						&& el.status != ''
						&& el.statusType
						&& el.statusType != ''
						&& el.statusType.toLowerCase() != 'nextrenewaldate'){
						//Ignore the title=Y Next Renewal Dates.  We are only using where Title = N
						//temp code to prevent unknown status types getting through
							newData.push(el);
					} else if(el.statusType == 'PlanningConditionUnapproved'
						&& el.status.toLowerCase() != 'passed'
						&& el.status.toLowerCase() != 'successful'
						&& el.status != ''
						&& el.statusType != ''){
						if(!addedPlanningConditionsTitle){
							var titleEl = $.extend({},el);
							if(AvailableFeatures.PortalDescriptionHTML()){
									titleEl.itemPortalDescriptionHTML = i18n.t('CIVICS.INSTRUMENT_DETAIL.PLANNING_CONDITIONS_APPROVAL');
							} else {
									titleEl.itemPortalDescription = i18n.t('CIVICS.INSTRUMENT_DETAIL.PLANNING_CONDITIONS_APPROVAL');
							}
							titleEl.title = 'y';
							newData.push(titleEl);
							addedPlanningConditionsTitle = true;
						}
					} else if (el.statusType && el.statusType.toLowerCase() == 'formula'
						&& el.title.toLowerCase() == 'n'){
						el.title = 'Y';
						newData.push(el);
					} else if (el.statusType && el.statusType.toLowerCase() == 'nextrenewaldate'
						&& el.title.toLowerCase() == 'n'){
						el.title = 'Y';
						newData.push(el);
					}
				});
				//place the failed checks under their parent checks
				$.each(newData, function (index, check) {
					var id = check.processStateStatusCheckId;
					check.subItems = [];
					$.each(data, function (index, el) {
						if (el.title.toLowerCase() == 'n'
							&& el.status.toLowerCase() != 'passed'
							&& el.status.toLowerCase() != 'successful'
							&& el.status != ''
							&& el.statusType.toLowerCase() != 'status'
							&& el.processStateStatusCheckId == id
							&& el.statusType != '') {
							check.subItems.push(el);
						}
					});
				});
				data = newData;
			}
			var count = 0;
			// if title is N and status is pending  OR if title is Y an status is Failed and type is constraint
			$.each(data, function(index, item) {
				if ((item.status.toUpperCase() == "PENDING" && item.title.toUpperCase() == 'Y') || (item.status.toUpperCase() == "FAILED" && item.statusType.toUpperCase() == 'REQUIRED')
				|| ((item.status.toUpperCase() == "FAILED" ||  item.status.toUpperCase() == "PENDING") && item.statusType.toUpperCase() == "FORMULA")
				|| (item.status.toUpperCase() == 'FAILED' && item.statusType.toUpperCase() == 'REQUIREDFILE' )
				) {
					count++;
				}
			});
			this.blockingCount = count;
			return data;
		}
	});
})
;
